import { PromptInputProps } from "@amzn/awsui-components-react/polaris/prompt-input";
import { MENTION_RE } from "./mentions";

/**
 * Conversion between a comment's plain text and Cloudscape PromptInput tokens. A mention is a
 * reference token (`value` = alias) and serialises back to `@alias`; a line break is a `break`
 * token. Only aliases in `known` become reference tokens — other `@words` stay text, matching what
 * the backend will accept.
 */
type Token = PromptInputProps.InputToken;

export const MENTION_MENU_ID = "people";

export function tokensToText(tokens: readonly Token[]): string {
  return tokens
    .map((t) => {
      if (t.type === "break") return "\n";
      if (t.type === "reference") return `@${t.value}`;
      if (t.type === "trigger") return `${t.triggerChar}${t.value}`;
      return t.value;
    })
    .join("");
}

// Same pattern as highlighting; its own RegExp so lastIndex is not shared.
const MENTION_IN_LINE = new RegExp(MENTION_RE.source, MENTION_RE.flags);

function lineTokens(
  line: string,
  known: ReadonlySet<string>,
  lineIndex: number
): Token[] {
  const out: Token[] = [];
  let last = 0;
  Array.from(line.matchAll(MENTION_IN_LINE))
    .filter((m) => known.has(m[1].toLowerCase()))
    .forEach((m) => {
      const at = m.index ?? 0;
      if (at > last) out.push({ type: "text", value: line.slice(last, at) });
      const alias = m[1].toLowerCase();
      out.push({
        type: "reference",
        id: `mention-${lineIndex}-${at}-${alias}`,
        label: alias,
        value: alias,
        menuId: MENTION_MENU_ID,
      });
      last = at + m[0].length;
    });
  if (last < line.length) out.push({ type: "text", value: line.slice(last) });
  return out;
}

export function textToTokens(
  text: string,
  known: ReadonlySet<string>
): Token[] {
  const tokens: Token[] = [];
  text.split("\n").forEach((line, i) => {
    if (i > 0) tokens.push({ type: "break", value: "\n" });
    tokens.push(...lineTokens(line, known, i));
  });
  return tokens;
}
